import React from 'react'

import MainHeader from 'components/navigation/MainHeader'
import HomeContent from 'components/modules/home/HomeContent'

const HomePage: React.FC = () => {
  const crumbsItems = [
    {
      label: 'Overview',
      isActive: true,
    },
  ]

  return (
    <>
      <MainHeader crumbsItems={crumbsItems} />

      <HomeContent />
    </>
  )
}

export default HomePage
